<!-- <app-loader *ngIf="isLoading()" /> -->

<div class="dialog-header">
  <h6>{{ isEditMode ? 'Edit Port Agent' : 'Add Port Agent' }}</h6>
  <button mat-icon-button class="close-icon" (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</div>

<form [formGroup]="portAgentForm">
  <mat-form-field appearance="outline" class="inputWidthForWindowFill">
    <mat-label>Port Agent</mat-label>
    <input matInput formControlName="company_name"
      (paste)="onPaste($event)" />
    <mat-error *ngIf="portAgentForm.get('company_name')?.hasError('required')">
      Port Agent Name is required.
    </mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline" class="example-chip-list" class="inputWidthForWindowFill">
    <mat-chip-grid #chipGrid>
      <mat-chip *ngFor="let email of emailList" [removable]="removable" (removed)="removeEmail(email)">
        {{ email }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
      </mat-chip>
      <input placeholder="Add email, press enter or comma" [matChipInputFor]="chipGrid" class="inputTextArea"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addEmail($event)">
    </mat-chip-grid>
  </mat-form-field>
  <mat-form-field appearance="outline" class="inputWidthForWindowFill">
    <mat-label>Billing Address</mat-label>
    <textarea matInput rows="3" formControlName="address"></textarea>
    <mat-error *ngIf="portAgentForm.get('address')?.hasError('required')">
      Billing Address is required.
    </mat-error>
  </mat-form-field>
  <br>
  <!-- BankDetails and billing Address -->
  <span class="bankDtlsHeader">Enter Bank Details & Billing Address</span>
  <hr>
  <br>
  <mat-form-field appearance="outline">
    <mat-label>Beneficiary account Holder Name</mat-label>
    <input matInput formControlName="accountHolderName" />
    <!-- <mat-error *ngIf="portAgentForm.get('accountHolderName')?.hasError('required')">
      Account Holder Name is required.
    </mat-error> -->
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Bank Name</mat-label>
    <input matInput formControlName="bankName" (blur)="onInputTrim('bankName');" (paste)="onPaste($event)" />
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Account Number</mat-label>
    <input matInput formControlName="accountNumber" (blur)="onInputTrim('accountNumber');" (paste)="onPaste($event)" />
    <!-- <mat-error *ngIf="portAgentForm.get('accountNumber')?.hasError('required')">
      Account Number is required.
    </mat-error> -->
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Correspondent Account Number</mat-label>
    <input matInput formControlName="correspondentAccountNumber" (blur)="onInputTrim('correspondentAccountNumber');"
      (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>IBAN Number</mat-label>
    <input matInput formControlName="ibanNumber" (blur)="onInputTrim('correspondentAccountNumber');"
      (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>SWIFT </mat-label>
    <input matInput formControlName="swiftCode" (blur)="onInputTrim('swiftCode');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>BIC Code </mat-label>
    <input matInput formControlName="bicCode" (blur)="onInputTrim('bicCode');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>INN Code </mat-label>
    <input matInput formControlName="inCode" (blur)="onInputTrim('inCode');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>BIK Code </mat-label>
    <input matInput formControlName="bikCode" (blur)="onInputTrim('bikCode');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>IFSC Code</mat-label>
    <input matInput formControlName="ifscCode" (blur)="onInputTrim('ifscCode');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Country</mat-label>
    <input matInput formControlName="country" (blur)="onInputTrim('country');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Currency</mat-label>
    <input matInput formControlName="currency" (blur)="onInputTrim('currency');" (paste)="onPaste($event)" />

  </mat-form-field>
  <mat-form-field appearance="outline" class="inputWidthForWindowFill">
    <mat-label>Bank Branch with Address</mat-label>
    <textarea matInput rows="3" formControlName="bankBranchAddress"></textarea>

  </mat-form-field>
</form>
<div>
  <button mat-flat-button color="primary" class="add-port-agent" type="button" (click)="onSubmit()">
    {{ isEditMode ? 'Update Port Agent' : 'Add Port Agent' }}
  </button>
</div>
